import { RegisteredOwnerSummaryView } from '@mark43/dex-api';
import { VStack, Card, CardBody, CardHeader, Text, DataList, DataItem } from '@cad-arc';
import { compact } from 'lodash';

export function DexPersonResultSummary({ person }: { person: RegisteredOwnerSummaryView }) {
    const { addressCity, addressStateCode, addressStreet, addressZipCode } = person;
    const address = compact([
        compact([addressStreet, addressCity]).join(' '),
        compact([addressStateCode, addressZipCode]).join(' '),
    ]).join(', ');
    return (
        <Card>
            <CardHeader title="Person" />
            <CardBody>
                <VStack align="left">
                    <Text variant="headingSm">{person.name}</Text>
                    <DataList>
                        <DataItem dataKey="DOB">{person.birthDate}</DataItem>
                        <DataItem dataKey="DL #">{person.operatorLicenseNumber}</DataItem>
                        <DataItem dataKey="Address">{address}</DataItem>
                    </DataList>
                </VStack>
            </CardBody>
        </Card>
    );
}
